import { render, staticRenderFns } from "./UpdateRestrictedDate.vue?vue&type=template&id=a17bacde&"
import script from "./UpdateRestrictedDate.vue?vue&type=script&lang=js&"
export * from "./UpdateRestrictedDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports